var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chatbotInfo.isUse && !_vm.isExist)?_c('div',{staticClass:"floating_chat"},[_c('div',{attrs:{"id":"isusys-chatbot-wrapper"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }